<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules"
    >
        <CForm @submit.prevent>
            <CInput
                v-model="model.code"
                horizontal
                label="Код"
                placeholder="Введите промокод"
                :is-valid="errors.code && errors.code.isValid"
            />

            <CTextarea
                v-model="model.description"
                horizontal
                label="Описание промокода (будет отображаться пользователю в приложении)"
                placeholder="Введите описание промокода"
                :is-valid="errors.description && errors.description.isValid"
            />

            <CRow
                v-if="allRestaurants"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Рестораны </CCol>
                <CCol sm="9">
                    <div>
                        <CInputCheckbox
                            :checked.sync="model.all_restaurants"
                            label="Все рестораны"
                            class="font-bold"
                        />
                    </div>
                    <div class="flex flex-wrap">
                        <div
                            v-for="restaurant in allRestaurants"
                            :key="restaurant.id"
                            class="w-1/4"
                        >
                            <CInputCheckbox
                                :checked.sync="restaurantsSelected[restaurant.id]"
                                :label="restaurant.title"
                                :disabled="model.all_restaurants"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <CRow
                v-if="allGrocers"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Магазины продуктов
                </CCol>
                <CCol sm="9">
                    <div>
                        <CInputCheckbox
                            :checked.sync="model.all_grocers"
                            label="Все магазины продуктов"
                            class="font-bold"
                        />
                    </div>
                    <div class="flex flex-wrap">
                        <div
                            v-for="grocer in allGrocers"
                            :key="grocer.id"
                            class="w-1/4">
                            <CInputCheckbox
                                :checked.sync="grocersSelected[grocer.id]"
                                :label="grocer.title"
                                :disabled="model.all_grocers"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <CRow
                v-if="allPharmacies"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Аптеки </CCol>
                <CCol sm="9">
                    <div>
                        <CInputCheckbox
                            :checked.sync="model.all_pharmacy"
                            label="Все аптеки"
                            class="font-bold"
                        />
                    </div>
                    <div class="flex flex-wrap">
                        <div
                            v-for="pharmacy in allPharmacies"
                            :key="pharmacy.id"
                            class="w-1/4"
                        >
                            <CInputCheckbox
                                :checked.sync="pharmaciesSelected[pharmacy.id]"
                                :label="pharmacy.title"
                                :disabled="model.all_pharmacy"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div v-if="entityTypes">
                <CRow
                    v-for="type in entityTypes"
                    :key="type.id"
                    form
                    class="form-group">
                    <CCol
                        tag="label"
                        class="col-form-label"
                        sm="3"> {{ type.title }} </CCol>
                    <CCol sm="9">
                        <div>
                            <CInputCheckbox
                                :checked.sync="entityTypesSelected[type.id]"
                                :label="`Все сервисы «${type.title}»`"
                                class="font-bold"
                                @change="disableEntity($event, type.code)"
                            />
                        </div>
                        <div v-if="type.services && type.services.length" class="flex flex-wrap">
                            <div
                                v-for="entity in type.services"
                                :key="entity.id"
                                class="w-1/4"
                            >
                                <CInputCheckbox
                                    :checked.sync="entitiesSelected[entity.id]"
                                    :label="entity.title"
                                    :disabled="disabledEntities[type.code]"
                                />
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </div>

            <CInput
                v-model="model.min_sum"
                horizontal
                label="Минимальная сумма заказа"
                placeholder="Введите минимальную сумму заказа"
                :is-valid="errors.min_sum && errors.min_sum.isValid"
            />

            <CRow class="mb-2 mt-6">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Дата начала:
                </CCol>
                <CCol class="p-0 ml-2" sm="3">
                    <DatePicker
                        v-model="datepicker.dateFrom"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
            </CRow>
            <CRow class="mb-6">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Дата окончания:
                </CCol>
                <CCol class="p-0 ml-2" sm="3">
                    <DatePicker
                        v-model="datepicker.dateTo"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
            </CRow>
            <CRow class="pl-3 mb-4">
                <CButton
                    color="light"
                    class="mr-3"
                    @click="resetDate"
                >Сброс дат</CButton>
            </CRow>

            <CInput
                v-model="model.term_day"
                horizontal
                label="Время жизни промокода (в днях)"
                placeholder="Введите количество дней"
            />

            <CInput
                v-model="model.term_count"
                horizontal
                label="Количество заказов (разрешенное)"
                placeholder="Введите количество заказов"
                :is-valid="errors.term_count && errors.term_count.isValid"
            />

            <CInput
                v-model="model.max_term_count_for_user"
                horizontal
                label="Сколько максимально заказов может быть у пользователя, чтобы он смог применить промокод (0 - новички без заказов, 10000 - все смогут применить)"
                placeholder="Введите количество заказов"
                :is-valid="errors.max_term_count_for_user && errors.max_term_count_for_user.isValid"
            />

            <CInput
                v-model="model.min_term_count_for_user"
                horizontal
                label="Сколько минимально заказов должно быть у пользователя, чтобы он смог применить промокод"
                placeholder="Введите количество заказов"
                :is-valid="errors.min_term_count_for_user && errors.min_term_count_for_user.isValid"
            />

            <CInput
                v-model="model.discount_percent"
                horizontal
                label="Размер скидки (%)"
                placeholder="Введите размер скидки (%)"
                :is-valid="errors.discount_percent && errors.discount_percent.isValid"
            />

            <CInput
                v-model="model.discount_sum"
                horizontal
                label="Размер скидки (руб.)"
                placeholder="Введите размер скидки (руб.)"
                :is-valid="errors.discount_sum && errors.discount_sum.isValid"
            />

            <CInput
                v-model="model.entity_discount_percent"
                horizontal
                label="Размер скидки от ресторана (%)"
                placeholder="Введите размер скидки от ресторана (%)"
                :is-valid="errors.entity_discount_percent && errors.entity_discount_percent.isValid"
            />

            <CInput
                v-model="model.entity_discount_sum"
                horizontal
                label="Размер скидки от ресторана (руб.)"
                placeholder="Введите размер скидки от ресторана (руб.)"
                :is-valid="errors.entity_discount_sum && errors.entity_discount_sum.isValid"
            />

            <CInput
                v-model="model.mircity_commission"
                horizontal
                label="Размер комиссии МИРСИТИ (%)"
                placeholder="Введите размер комиссии МИРСИТИ  (%)"
                :is-valid="errors.mircity_commission && errors.mircity_commission.isValid"
            />

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Отправлять в интеграции (скидка от партнера)
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.accounting_in_integration"
                    />
                </CCol>
            </CRow>


            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label font-bold"
                    sm="3">
                    Промокод для РЕФЕРАЛА (промокод который получит клиент получивший чей-то "личный промокод")
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_referal"
                    />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label font-bold"
                    sm="3">
                    Промокод для РЕФЕРЕРА  (промокод который получит клиент раздавший свой "личный промокод")
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_referer"
                    />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label font-bold"
                    sm="3">
                    Промокод для "Скидка за n-заказов"
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_discount_on_orders"
                    />
                </CCol>
            </CRow>


            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label font-bold"
                    sm="3">
                    Автоприменение
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.auto_apply"
                    />
                </CCol>
            </CRow>

            <CInput
                v-if="model.auto_apply"
                v-model="model.priority"
                style="margin-left: 20px"
                horizontal
                type="number"
                label="Приоритет автоприменения"
                placeholder="Введите приоритет автоприменения промокода (по стандарту стоит 100)"
            />

            <CInput
                v-model="model.referer_code_title"
                horizontal
                label="Заголовок промокода для РЕФЕРЕРА"
                placeholder="Введите заголовок"
            />

            <CInput
                v-model="model.referer_code_description"
                horizontal
                label="Описание промокода для РЕФЕРЕРА"
                placeholder="Введите описание"
            />

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Бесплатная доставка
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.free_delivery"
                    />
                </CCol>
            </CRow>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Показать пользователям в списке
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.show_customers"
                    />
                </CCol>
            </CRow>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Создавать пользователю при регистрации
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.generate_on_registration"
                    />
                </CCol>
            </CRow>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Использовать для награды за опросы
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.generate_on_survey"
                    />
                </CCol>
            </CRow>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Тип доставки</CCol>
                <CCol sm="9">
                    <CSelect
                        inline
                        :value.sync="model.delivery_type"
                        :options="delivery_types"
                        placeholder="Тип доставки..."
                    />
                </CCol>
            </CRow>

            <CModal
                title="Подтверждение"
                color="danger"
                :show.sync="disabledModal"
                :footer="false">
                <template>
                    <div slot="body-wrapper" class="modal-body">
                        <p>
                            Укажите причину создания или редактирования промокода.
                        </p>
                        <br>
                        <div>
                            <label>Причина создания (редактирования):</label>
                            <CInput
                                v-model="model.why_is_it_off"
                                placeholder="Причина"
                            />
                        </div>
                    </div>
                    <div slot="footer">
                        <CButton
                            color="light"
                            class="ml-3"
                            @click="disabledModal = false">Отмена</CButton>
                        <CButton
                            color="danger"
                            class="ml-3"
                            @click="saveDisabledService">Сохранить</CButton>
                    </div>
                </template>
            </CModal>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Включено </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled"
                    />
                </CCol>
            </CRow>

            <div class="flex mt-4">
                <CButton
                    color="primary"
                    @click="submit"
                >{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete"
                >Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete"
        />
    </AppFormValidator>
</template>

<script>
    import to from 'await-to-js';
    import DatePicker from 'vuejs-datepicker';
    import moment from 'moment';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import { morphism } from 'morphism';
    import { requiredRule } from '@/utils/rules';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            DatePicker,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
            customerId: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                checkReferalProgram: false,
                model: {},
                schema: {
                    id: 'id',
                    code: 'code',
                    description: 'description',
                    min_sum: 'min_sum',
                    date_start: 'date_start',
                    date_finish: 'date_finish',
                    term_count: 'term_count',
                    term_day: 'term_day',
                    max_term_count_for_user: 'max_term_count_for_user',
                    min_term_count_for_user: 'min_term_count_for_user',
                    discount_percent: 'discount_percent',
                    discount_sum: 'discount_sum',
                    entity_discount_percent: 'entity_discount_percent',
                    entity_discount_sum: 'entity_discount_sum',
                    mircity_commission: 'mircity_commission',
                    restaurants: 'restaurants',
                    grocers: 'grocers',
                    pharmacy: 'pharmacy',
                    assistants: 'assistants',
                    entity_types: 'entity_types',
                    entities: 'entities',
                    delivery_type: 'delivery_type',
                    referer_code_title: 'referer_code_title',
                    referer_code_description: 'referer_code_description',
                    priority: 'priority',

                    why_is_it_off: 'why_is_it_off',
                    who_turned_off: 'who_turned_off',
                    shutdown_date: 'shutdown_date',

                    all_restaurants: source => Boolean(source.all_restaurants),
                    all_grocers: source => Boolean(source.all_grocers),
                    all_pharmacy: source => Boolean(source.all_pharmacy),
                    all_assistants: source => Boolean(source.all_assistants),
                    enabled: source => Boolean(source.enabled),
                    free_delivery: source => Boolean(source.free_delivery),
                    accounting_in_integration: source => Boolean(source.accounting_in_integration),
                    for_referal: source => Boolean(source.for_referal),
                    for_referer: source => Boolean(source.for_referer),
                    for_discount_on_orders: source => Boolean(source.for_discount_on_orders),
                    show_customers: source => Boolean(source.show_customers),
                    generate_on_registration: source => Boolean(source.generate_on_registration),
                    generate_on_survey: source => Boolean(source.generate_on_survey),
                    auto_apply: source => Boolean(source.auto_apply),

                },
                rules: {
                    code: [requiredRule],
                    description: [requiredRule],
                    min_sum: [requiredRule],
                    enabled: [requiredRule],
                    term_count: [requiredRule],
                },
                // Restaurants
                allRestaurants: [],
                restaurantsSelected: [],
                // Grocers
                allGrocers: [],
                grocersSelected: [],
                // Pharmacies
                allPharmacies: [],
                pharmaciesSelected: [],
                // Assistants
                allAssistants: [],
                assistantsSelected: [],
                // Entity types
                entityTypes: [],
                entityTypesSelected: [],
                entitiesSelected: [],
                disabledEntities: {},
                delivery_types: null,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                disabledModal: false,
                allowedSave: false,
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },

        },

        async mounted(){
            try {
                const id = this.$route.params.id;
                if (id) {
                    const promocode = await this.axios.get('/promocodes/' + id);
                    if(promocode.data.date_start) {
                        this.model.date_start = moment(promocode.data.date_start).format('YYYY-MM-DD');
                        this.datepicker.dateFrom = moment(promocode.data.date_start).format('YYYY-MM-DD');
                    }
                    if(promocode.data.date_finish) {
                        this.datepicker.dateTo = moment(promocode.data.date_finish).format('YYYY-MM-DD');
                        this.model.date_finish = moment(promocode.data.date_finish).format('YYYY-MM-DD');
                    }
                }
                if(!this.delivery_types) {
                    const types = [];
                    types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                    types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                    types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                    types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });
                    types.push({ value: null, label: 'Без типа доставки' });
                    this.delivery_types = types;
                }
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка при загрузке данных ' + e);
            }
        },

        created() {
            this.setModel();
            this.initBusiness();
        },

        methods: {
            disableEntity(event, code) {
                this.disabledEntities[code] = event.target.checked;
            },
            setModel() {
                this.model = morphism(this.schema, this.entity);
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;

                if (!this.allowedSave) {
                    this.disabledModal = true;
                    return;
                }

                this.delivery_type === this.model.delivery_type;

                // Restaurants
                const restaurants = [];
                for (const restaurant of this.allRestaurants) {
                    if (this.restaurantsSelected[restaurant.id]) {
                        restaurants.push(restaurant.id);
                    }
                }
                payload.restaurants = restaurants;
                // Grocers
                const grocers = [];
                for (const grocer of this.allGrocers) {
                    if (this.grocersSelected[grocer.id]) {
                        grocers.push(grocer.id);
                    }
                }
                payload.grocers = grocers;
                // Pharmacies
                const pharmacies = [];
                for (const pharmacy of this.allPharmacies) {
                    if (this.pharmaciesSelected[pharmacy.id]) {
                        pharmacies.push(pharmacy.id);
                    }
                }
                payload.pharmacy = pharmacies;
                // Assistants
                const assistants = [];
                for (const assistant of this.allAssistants) {
                    if (this.assistantsSelected[assistant.id]) {
                        assistants.push(assistant.id);
                    }
                }
                payload.assistants = assistants;
                // Entities
                const entities = [];
                const entityTypes = [];
                if (this?.entityTypes?.length) {
                    for (const type of this.entityTypes) {
                        if (this.entityTypesSelected[type.id]) {
                            entityTypes.push(type.id);
                        }
                        if (type?.services?.length) {
                            for (const entity of type.services) {
                                if (this.entitiesSelected[entity.id]) {
                                    entities.push(entity.id);
                                }
                            }
                        }
                    }
                }
                payload.entities = entities;
                payload.entity_types = entityTypes;

                if (!payload.min_sum) payload.min_sum = 0;
                if (!payload.term_count) payload.term_count = 0;
                if (!payload.discount_percent) payload.discount_percent = 0;
                if (!payload.discount_sum) payload.discount_sum = 0;
                payload.max_term_count_for_user = payload.max_term_count_for_user === '' ? null : +payload.max_term_count_for_user;
                payload.min_term_count_for_user = payload.min_term_count_for_user === '' ? null : +payload.min_term_count_for_user;
                payload.entity_discount_percent = payload.entity_discount_percent ? +payload.entity_discount_percent : null;
                payload.entity_discount_sum = payload.entity_discount_sum ? +payload.entity_discount_sum : null;
                payload.mircity_commission = payload.mircity_commission ? +payload.mircity_commission : null;
                payload.term_day = payload.term_day ? +payload.term_day : null;
                payload.date_start = this.datepicker.dateFrom ? moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD') : null;
                payload.date_finish = this.datepicker.dateTo ? moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD') : null;
                payload.priority = payload.priority ? +payload.priority : null;

                payload.why_is_it_off = payload.why_is_it_off ? '' + payload.why_is_it_off : null;
                delete payload.who_turned_off;
                delete payload.shutdown_date;

                if (this.customerId) {
                    payload.customer_id = this.customerId;
                }

                if (typeof id === 'number') {
                    const [err] = await to(this.axios.put(`/promocodes/${id}`, payload));
                    if (err) {
                        if (err?.response?.data?.error === 'Promo code already exists') {
                            return this.$root.$emit('showError', 'Ошибка. Промокод уже существует.');
                        } else {
                            return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                        }
                    }
                } else {
                    const [err] = await to(this.axios.post('/promocodes', payload));
                    if (err) {
                        if (err?.response?.data?.error === 'Promo code already exists') {
                            return this.$root.$emit('showError', 'Ошибка. Промокод уже существует.');
                        } else {
                            return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись.');
                        }
                    }
                }

                this.allowedSave = false;
                this.customerId ? this.$router.push(`/customers/${this.customerId}/promocodes`) : this.$emit('success');
            },

            async saveDisabledService() {
                if (!this.model.why_is_it_off) {
                    alert('Укажите причину создания или редактирования');
                    return;
                }
                this.allowedSave = true;
                this.disabledModal = false;

                await this.submit();
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            resetDate() {
                this.datepicker.dateFrom = null;
                this.datepicker.dateTo = null;
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/promocodes/${this.model.id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка удаления записи.');
                }

                this.$emit('deleted');
            },

            async initBusiness() {
                // Restaurants
                this.allRestaurants = (await this.axios.get('/restaurants')).data;
                // Grocers
                this.allGrocers = (await this.axios.get('/grocers')).data;
                // Pharmacies
                this.allPharmacies = (await this.axios.get('/pharmacies')).data;
                // Assistants
                this.allAssistants = (await this.axios.get('/assistants')).data;
                // Entities
                this.entityTypes = (await this.axios.get('/entities-type')).data;
                this.entityTypes = await Promise.all(this.entityTypes.map(async type => {
                    this.disabledEntities[type.code] = false;
                    type.services = (await this.axios.get(`/entities/${type.code}`)).data;
                    return type;
                }));
                this.initBusinessSelected();
            },

            initBusinessSelected() {
                // Restaurants
                this.allRestaurants.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allRestaurants.length) {
                    for (const restaurant of this.allRestaurants) {
                        this.restaurantsSelected[restaurant.id] = false;
                    }
                }
                if (
                    this.model &&
                    this.model.restaurants &&
                    this.model.restaurants.length
                ) {
                    for (const restaurant of this.model.restaurants) {
                        this.restaurantsSelected[restaurant] = true;
                    }
                }
                // Grocers
                this.allGrocers.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allGrocers.length) {
                    for (const grocer of this.allGrocers) {
                        this.grocersSelected[grocer.id] = false;
                    }
                }
                if (this.model && this.model.grocers && this.model.grocers.length) {
                    for (const grocer of this.model.grocers) {
                        this.grocersSelected[grocer] = true;
                    }
                }
                // Pharmacies
                this.allPharmacies.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allPharmacies.length) {
                    for (const pharmacy of this.allPharmacies) {
                        this.pharmaciesSelected[pharmacy.id] = false;
                    }
                }
                if (this.model && this.model.pharmacy && this.model.pharmacy.length) {
                    for (const pharmacy of this.model.pharmacy) {
                        this.pharmaciesSelected[pharmacy] = true;
                    }
                }
                // Assistants
                this.allAssistants.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.allAssistants.length) {
                    for (const assistant of this.allAssistants) {
                        this.assistantsSelected[assistant.id] = false;
                    }
                }
                if (this.model && this.model.assistants && this.model.assistants.length) {
                    for (const assistant of this.model.assistants) {
                        this.assistantsSelected[assistant] = true;
                    }
                }
                // Entities
                this.entityTypes.sort((a, b) => a.title > b.title ? 1 : -1);
                if (this.entityTypes.length) {
                    for (const type of this.entityTypes) {
                        this.entityTypesSelected[type.id] = false;
                        if (this.model && this.model.entity_types && this.model.entity_types.length) {
                            for (const id of this.model.entity_types) {
                                if (type.id === id) {
                                    this.disabledEntities[type.code] = true;
                                }
                            }
                        }
                    }
                }
                if (this.model && this.model.entity_types && this.model.entity_types.length) {
                    for (const type of this.model.entity_types) {
                        this.entityTypesSelected[type] = true;
                    }
                }
                if (this.entityTypes.length) {
                    for (const type of this.entityTypes) {
                        for (const entity of type.services) {
                            this.entitiesSelected[entity.id] = false;
                        }
                    }
                }
                if (this.model && this.model.entities && this.model.entities.length) {
                    for (const entity of this.model.entities) {
                        this.entitiesSelected[entity] = true;
                    }
                }
            },
        },
    };
</script>
<style>
input.custom-datepicker {
    padding: 0.375rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
}
</style>
